import HELPER from '@/app/utils/HELPER';
import { Atom } from '../Atom';
import { BaseAtomRender } from '../atom-service/render/BaseAtomRender';
import { AtomServiceExportData } from '../atom-service/export/AtomServiceExportData';
import type { AtomModel, FormControlSetting, TypeExportData } from '../Atom.model';
import { DataManager } from '../service/DataManager';
declare let Liquid: any;

const FormControlSettings: FormControlSetting[] = [
  {
    type: 'html:attr',
    name: 'page_quantity',
    targetSelector: '.gf_collection-paginator-wrapper',
    property: 'data-product-count',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'previous_text',
    targetSelector: '.module',
    property: 'data-previous',
    refreshType: 'all',
  },
  {
    type: 'html:attr',
    name: 'next_text',
    targetSelector: '.module',
    property: 'data-next',
    refreshType: 'all',
  },
  {
    type: 'html:extraClass',
    name: 'extraClass',
    targetSelector: '.module',
    property: 'data-exc',
  },
  {
    type: 'custom:align',
    name: 'align_lg',
    targetSelector: '.module',
    attrStoredSelector: '.module',
    property: '',
  },
  {
    type: 'custom:align',
    name: 'align_md',
    targetSelector: '.module',
    attrStoredSelector: '.module',
    property: '',
  },
  {
    type: 'custom:align',
    name: 'align_sm',
    targetSelector: '.module',
    attrStoredSelector: '.module',
    property: '',
  },
  {
    type: 'custom:align',
    name: 'align_xs',
    targetSelector: '.module',
    attrStoredSelector: '.module',
    property: '',
  },
  {
    type: 'css:font-style',
    name: 'font-style',
    targetSelector: '.gf_collection-paginator-wrapper',
    targetSelectors: ['span.page', 'span.deco', 'span.prev', 'span.next'],
    property: '',
  },
  {
    type: 'paginator:layout',
    name: 'layout',
    property: '',
  },
  {
    type: 'paginator:layout',
    name: 'btn-shape',
    property: '',
  },
  {
    type: 'paginator:layout',
    name: 'btn-size',
    property: '',
  },
  {
    type: 'paginator:btn-spacing',
    name: 'btn-spacing',
    property: '',
  },
  {
    type: 'paginator:text',
    name: 'text_color',
    property: 'color',
    targetSelector: '.gf_collection-paginator-wrapper',
  },
  {
    type: 'paginator:text',
    name: 'active_color',
    property: 'color',
    targetSelector: 'span.current',
  },
  {
    type: 'paginator:text',
    name: 'font-size',
    property: 'font-size',
    targetSelector: 'span.page',
    targetSelectors: ['span.page', 'span.deco', 'span.prev', 'span.next'],
  },
];

/**
 * PaginatorRender
 */
export class PaginatorRender extends BaseAtomRender {
  /**
   * [Filter] [Init]
   * Parse chuỗi có cấu trúc Liquid thành HTML dạng Promise
   * @param templateTmp chuỗi template có chứa code liquid cần format
   * @returns trả về một chuỗi HTML
   */
  async renderLiquid(templateTmp: string): Promise<string> {
    const template = HELPER.simpleHTMLEntities(templateTmp);
    const atomModel = this.getAtomModel();
    templateTmp = HELPER.replaceFields(atomModel.settings, templateTmp);
    // Render liquid
    const tmpl = Liquid.parse(template);
    const html: string = tmpl.render({
      ...this.getAtomModel().data,
    });
    return html;
  }

  /**
   * render
   */
  async render() {
    const pageType = this.atom.$gfFrame.data('gfframe').getPageType();
    if (pageType == 'template-collection') {
      HELPER.generatePlaceholderForm(this.get$el());
    }
    await super.render();
    if (pageType == 'page-collection') {
      HELPER.generatePlaceholderForm(this.get$el());
    }
  }
}

/**
 * PaginatorExport
 */
export class PaginatorExport extends AtomServiceExportData {
  /**
   * renderTemplateExport
   * @param $atomClone atomClone
   * @param html html
   * @param exportType exportType
   * @returns
   */
  renderTemplateExport($atomClone: JQuery, html: string, exportType?: string): JQuery {
    const moduleId = this.atom.getId();
    const atomModel = DataManager.getDataSetting(moduleId).atom;

    let templateTmp = HELPER.replaceFields(atomModel.settings, atomModel.html);
    if (templateTmp != undefined) {
      templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id(\S*\s+)?}}/g, moduleId);
      const moduleIdSlug = moduleId.toString().replace(/-/g, '');
      templateTmp = templateTmp.replace(/{{(\S*\s+)?module-id-slug(\S*\s+)?}}/g, moduleIdSlug);
    } else {
      templateTmp = '';
    }
    // Process liquid
    const $templateTmpWrapper = jQuery('<div />').html(templateTmp);
    const $productList = this.atom.$gryffEditor.find('.module-wrap[data-label="Product List"][data-status="dynamic"]');
    let limit: any = 12; // Since Product List default limit is 12, it's better choice to choose this one for default paginator limit also
    if ($productList.length > 0) {
      limit = $productList.eq(0).children('.module').attr('data-limit');
    }
    if (exportType != 'block') {
      const previousText = $templateTmpWrapper.find('.module').attr('data-previous');
      const nextText = $templateTmpWrapper.find('.module').attr('data-next');
      $templateTmpWrapper
        .find('.gf_collection-paginator-wrapper')
        .html(
          '{% paginate collection.products by ' +
            limit +
            " %}{{ paginate | default_pagination: previous: '" +
            previousText +
            "', next: '" +
            nextText +
            "' }}{% endpaginate %}",
        );
    }
    return $atomClone.html($templateTmpWrapper.html());
  }

  /**
   * export
   * @param exportType exportType
   * @returns returns
   */
  export(exportType?: string): TypeExportData {
    const data = super.export(exportType);
    const moduleId = this.atom.getId();
    const atomModel = DataManager.getDataSetting(moduleId).atom;
    const settingsString = JSON.stringify(atomModel.settings);
    const $bk = jQuery(`<div>${data.bkHtml}</div>`);
    $bk.find('.settings').html(settingsString);
    data.bkHtml = $bk.html();
    return data;
  }
}

/**
 * GpPaginator
 */
export class GpPaginator extends Atom {
  /**
   * getDataAtom
   * @returns returns
   */
  getDataAtom(): AtomModel {
    const data: AtomModel = {
      type: this.getType(),
      id: this.getId(),
      nodeId: this.getIdNode(),
      name: 'Paginator',
      slug: 'paginator',
      groupName: 'Collection',
      settings: this.getSettings(),
      data: this.getDataChilds(),
      html: this.getTemplate(),
      class: 'module-wrap',
      style: this.getStyle(),
      script: this.getScript(),
      libs: this.getLibs(),
      fonts: [],
      version: 1,
      formControlSettings: FormControlSettings,
    };
    return data;
  }

  /**
   * @override initAtomRender
   */
  initAtomRender() {
    this.atomRender = new PaginatorRender(this);
  }

  /**
   * @override initAtomExport
   */
  initAtomExport() {
    this.atomServiceExportData = new PaginatorExport(this);
  }
}
